// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UxXt","content":"styles_content__1DacB"};